import PropTypes from 'prop-types';
import React from 'react';

import './DDCPlayerVideoComponent.scss';

class DDCPlayerVideoComponent extends React.Component {
	componentDidMount() {
		if (typeof DDC !== 'undefined') {
			if (
				this.props.video &&
				DDC.modules &&
				DDC.modules.video &&
				typeof $ !== 'undefined'
			) {
				/* eslint no-undef: 0 */
				$(document).trigger('modulesRefresh', DDC.modules.video);
			}
		}
	}

	render() {
		if (this.props.video) {
			const {
				viewportWidth,
				viewportHeight,
				video: { id, src },
				widgetInfo: { accountId, deviceType },
				modalSettings: { videoIsOpen },
				mobileOrientationIsPortrait
			} = this.props;

			let videoWidth = viewportWidth < 920 ? viewportWidth : 920;
			if (!mobileOrientationIsPortrait && /mobile/gi.test(deviceType)) {
				videoWidth = viewportHeight;
			}

			const baseClassNames = [
				'h-100',
				'd-flex',
				'justify-content-center',
				'align-items-center'
			];
			const wrapperClassNames = new Set([
				...baseClassNames,
				...['video-container', 'py-5']
			]);
			const playerClassNames = [
				...baseClassNames,
				...['ddcPlayer-holder']
			];

			if (!videoIsOpen) {
				wrapperClassNames.add('hide');
				wrapperClassNames.delete('d-flex');
			}

			return (
				<div className={[...wrapperClassNames].join(' ')}>
					<div
						id={`video-${id}`}
						className={playerClassNames.join(' ')}
						data-ddcplayerinfo={`${encodeURIComponent(
							src
						)}-${videoWidth}-${Math.round(videoWidth * 0.7)}`}
						data-accountid={`${accountId}`}
						data-useprepostroll="false"
						data-autoplay="false"
					/>
				</div>
			);
		}

		// No video - nothing to see here
		return null;
	}
}

DDCPlayerVideoComponent.propTypes = {
	widgetInfo: PropTypes.shape({
		accountId: PropTypes.string,
		deviceType: PropTypes.string
	}).isRequired,
	viewportWidth: PropTypes.number.isRequired,
	viewportHeight: PropTypes.number.isRequired,
	video: PropTypes.shape({
		id: PropTypes.number,
		src: PropTypes.string
	}),
	modalSettings: PropTypes.shape({
		videoIsOpen: PropTypes.bool
	}).isRequired,
	mobileOrientationIsPortrait: PropTypes.bool.isRequired
};

DDCPlayerVideoComponent.defaultProps = {
	video: {}
};

export default DDCPlayerVideoComponent;
